import React, { useEffect, useState } from 'react'
import styles from './role-management.module.scss'
import { useDispatch } from 'react-redux'
import { ACTION, PERMISSIONS } from 'consts'

//antd
import { Button, Input, Collapse, Popconfirm, notification, Empty } from 'antd'

//components
import CreateRole from './create-role'
import RoleTree from './role-tree'
import Permission from 'components/permission'
import TitlePage from 'components/title-page'

//apis
import { getRoles, deleteRole } from 'apis/role'

import { DeleteOutlined, SearchOutlined } from '@ant-design/icons'

export default function Role() {
  const dispatch = useDispatch()

  const [roles, setRoles] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)

  const _getRoles = async () => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      setLoading(true)
      const res = await getRoles()
      const data = res.data.data
      if (res.status === 200) {
        setRoles(data.filter((e) => e.role_id !== -1))
      }
      dispatch({ type: ACTION.LOADING, data: false })
      setLoading(false)
    } catch (error) {
      setLoading(false)

      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  useEffect(() => {
    _getRoles()
  }, [])

  const _deleteRole = async (roleId) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await deleteRole([roleId])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa vai trò thành công!' })
          _getRoles()
        } else {
          notification.error({
            message: res.data.message || 'Xóa vai trò thất bại, vui lòng thử lại',
          })
        }
      } else {
        notification.error({
          message: res.data.message || 'Xóa vai trò thất bại, vui lòng thử lại',
        })
      }
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }
  return (
    <div className={`${styles['payment_method']} ${styles['card']}`}>
      <TitlePage title="Quản lý phân quyền">
        <CreateRole _getRoles={_getRoles} dataRoles={roles} />
      </TitlePage>
      <br />
      <Input
        prefix={<SearchOutlined />}
        value={search}
        allowClear
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Tìm kiếm theo tên vai trò hoặc tên quyền"
        style={{ width: 400 }}
        size="large"
      />
      <div style={{ marginTop: 15 }}>
        {roles.length ? (
          <Collapse accordion>
            {roles.map((role, index) => (
              <Collapse.Panel
                extra={
                  // <Permission permissions={[PERMISSIONS.xoa_phan_quyen]}>
                  <Popconfirm
                    placement="topRight"
                    title="Bạn có muốn xóa vai trò này không?"
                    onCancel={(e) => {
                      e.stopPropagation()
                    }}
                    onConfirm={(e) => {
                      e.stopPropagation()
                      _deleteRole(role.role_id)
                    }}
                  >
                    <Button
                      icon={<DeleteOutlined />}
                      type="primary"
                      danger
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Popconfirm>
                  //  </Permission>
                }
                header={
                  <div
                    style={{
                      textTransform: 'uppercase',
                      display: 'inline-block',
                    }}
                  >
                    {search && role.name.toLowerCase().includes(search.toLowerCase()) ? (
                      <mark style={{ backgroundColor: '#00D3E0' }}>{role.name}</mark>
                    ) : (
                      role.name
                    )}
                  </div>
                }
                key={index}
              >
                <RoleTree search={search} role={role} _getRoles={_getRoles} />
              </Collapse.Panel>
            ))}
          </Collapse>
        ) : (
          !loading && (
            <Empty description={<span>Chưa có vai trò</span>}>
              <CreateRole txt="Thêm vai trò ngay" _getRoles={_getRoles} dataRoles={roles} />
            </Empty>
          )
        )}
      </div>
    </div>
  )
}
